import { render } from "./GWL.vue?vue&type=template&id=c09ae23a&scoped=true"
import script from "./GWL.vue?vue&type=script&lang=js"
export * from "./GWL.vue?vue&type=script&lang=js"

import "./GWL.vue?vue&type=style&index=0&id=c09ae23a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09ae23a"]])

export default __exports__